import classNames from 'classnames';
import React from 'react';
import styles from '../Form.module.scss';

type DefaultProps = React.DetailedHTMLProps<
  React.LabelHTMLAttributes<HTMLLabelElement>,
  HTMLLabelElement
>;

type FormLabelProps = DefaultProps & {
  isVisuallyHidden?: boolean;
};

const FormLabel = ({
  children,
  className,
  isVisuallyHidden = false,
  ...props
}: FormLabelProps) => {
  return (
    <label
      {...props}
      className={classNames(className, {
        [styles.visuallyHidden]: isVisuallyHidden,
      })}
    >
      {children}
    </label>
  );
};

export default FormLabel;
